import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { STATION } from "../mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RecentlyPlayed = () => {
  const [tracks, setTracks] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const res = await fetch(`${API}/recently-played?limit=5`);
        if (!res.ok) return;
        const data = await res.json();
        if (active && data && Array.isArray(data.tracks)) setTracks(data.tracks.slice(0, 5));
      } catch (e) {
        /* ignore transient errors */
      }
    };
    load();
    const id = setInterval(load, 12000);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  if (!tracks.length) return null;

  return (
    <div className="rounded-2xl bg-[#4288F5] border border-white/15 px-4 py-3 shadow-lg shadow-blue-900/20">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center justify-between text-left"
      >
        <div>
          <span className="text-[10px] font-bold uppercase tracking-widest text-white/70">Op All-In Radio</span>
          <p className="font-heading text-base font-extrabold text-white">Net gedraaid</p>
        </div>
        <span className="flex items-center gap-2 text-white/85">
          <span className="text-xs font-semibold">{open ? "Verberg" : "Toon laatste 5"}</span>
          <ChevronDown className={`h-5 w-5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
        </span>
      </button>

      {/* Collapsible content (smooth height animation) */}
      <div className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"}`}>
        <div className="overflow-hidden">
          <div className="divide-y divide-white/15">
            {tracks.map((t, i) => (
              <div key={`${t.raw}-${i}`} className="flex items-center gap-3 py-2.5">
                <span className="w-10 shrink-0 font-heading text-xs font-bold text-white/80">{t.time}</span>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-[#2E7DF7] to-[#1E6BE6] ring-1 ring-white/30">
                  {t.artwork ? (
                    <img
                      key={t.artwork}
                      src={t.artwork}
                      alt={t.song || t.raw}
                      className="h-full w-full object-cover"
                      data-testid="recent-artwork"
                      onError={(e) => { e.currentTarget.style.display = "none"; e.currentTarget.nextSibling.style.display = "block"; }}
                    />
                  ) : null}
                  <img
                    src={STATION.logoFull}
                    alt=""
                    className="h-full w-full object-contain p-2"
                    style={{ display: t.artwork ? "none" : "block" }}
                  />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-bold text-white">{t.song || t.raw}</p>
                  {t.artist ? <p className="text-xs text-white/70">{t.artist}</p> : null}
                </div>
                {i === 0 && (
                  <span className="shrink-0 rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
                    Nu
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentlyPlayed;
